import { getCsrfToken } from '@shared/csrfTokenService'

export default async function ksFetch(url, options) {
    const response = await fetch(url, {
        ...options,
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': getCsrfToken(),
            ...(options?.headers || {})
        }
    })

    let data = {};
    try {
        data = await response.json()
    } catch (error) {
        data = {
            flash: {
                alert: `Something went wrong: ${error.message}`
            }
        }
    }
    
    // Check for flash messages and dispatch toast events
    if (data.flash) {
        Object.entries(data.flash).forEach(([type, message]) => {
            if (message) {
                const toastType = type === 'notice' ? 'success' : type === 'warning' ? 'warning' : 'error'
                const event = new CustomEvent('show-toast', {
                    detail: {
                        message,
                        type: toastType
                    }
                });
                document.dispatchEvent(event);
            }
        });
    }

    return [data, response.status]
}